<template>
  <WsStateDropdownCheckboxLayers001
    v-model="systemClass.state"
    :placeholder="systemClass.placeholder"
    :menu="_systemClassMenu"
    outline
    class="w-full"
  />
</template>

<script>
export default {
  data() {
    return {
      systemClass: {
        placeholder: "選擇",
        state: [],
      },
    };
  },
  computed: {
    _systemClassMenu() {
      const systemClasses = [
        {
          id: 4,
          updated_at: "2021-03-15T05:35:10.000000Z",
          icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970289062siFK/%E7%92%B0%E4%BF%9D.png?signature=542130fa0b741fd0b28f9f9c599335cf4d387559971729a8ac9451fda349c61f",
          system_subclasses: [
            {
              sequence: "1",
              id: 14,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970290907Hxye/%E7%A9%BA%E6%B0%A3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=75c41b3967b7c580f710e6aa05a1b868d08521cd7495273a9b12736d91d7700d",
              locales: {
                tw: { name: "空氣污染防制" },
                cn: { name: "空气污染防制" },
              },
              name: "空氣污染防制",
            },
            {
              sequence: "2",
              id: 15,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970291166yRtf/%E6%B0%B4%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=7528b177496042d3318344d1aa5e5f0718a4001d945a0c2a8a35de2e8258e0b9",
              locales: {
                tw: { name: "水污染防治" },
                cn: { name: "水污染防治" },
              },
              name: "水污染防治",
            },
            {
              sequence: "3",
              id: 16,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1597029106MXgKP/%E5%9B%BA%E9%AB%94%E5%BB%A2%E7%89%A9%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=ad3a10bc3f516d753ff2afc5ae063aee3d60ac6fe1ee0d6cb47cfbb4396e0c54",
              locales: {
                tw: { name: "廢棄物清理" },
                cn: { name: "废弃物清理" },
              },
              name: "廢棄物清理",
            },
            {
              sequence: "4",
              id: 17,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/159702917197pRF/%E5%99%AA%E9%9F%B3%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=93c81cdb574ca9cbe3adaad68fc191c326f071524e74a05b9a11996ff5e0fcbf",
              locales: {
                tw: { name: "噪音污染管制" },
                cn: { name: "噪音污染管制" },
              },
              name: "噪音污染管制",
            },
            {
              sequence: "5",
              id: 18,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1597029126OUp6b/%E5%9C%9F%E5%A3%A4%E6%B1%A1%E6%9F%93%E9%98%B2%E6%B2%BB.png?signature=551ba1f8c7b9d291b4da9aebf54d489ef0998fee866de2661719e91d88a1cb36",
              locales: {
                tw: { name: "土壤及地下水防治" },
                cn: { name: "土壤及地下水防治" },
              },
              name: "土壤及地下水防治",
            },
            {
              sequence: "6",
              id: 19,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1629862124R0fss/ll-esh-toxicity.png?signature=292c3ffd90673b1f496c15e616c64bb96f08111e7abcaf0e81eef45fdaf12b31",
              locales: {
                tw: { name: "毒性及關注化學物質管理" },
                cn: { name: "危险化学品管理" },
              },
              name: "毒性及關注化學物質管理",
            },
          ],
          locales: { tw: { name: "環保" }, cn: { name: "环保" } },
          name: "環保",
        },
        {
          id: 7,
          updated_at: "2021-03-15T05:35:18.000000Z",
          icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/15970289203FQH1/%E7%94%9F%E7%94%A2%E5%AE%89%E5%85%A8.png?signature=8a638cebd70e4ff0473a218ff1685fd23f4b71e9e856020ba14bcfcc845ddfe2",
          system_subclasses: [
            {
              sequence: null,
              id: 23,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1597029226UcPd9/%E5%BB%BA%E7%AF%89%E6%B6%88%E9%98%B2.png?signature=d24c456ceab558b60c68744011d8fa3d6b3b39cc7aad185b468b3bef6e3f1157",
              locales: {
                tw: { name: "建築及消防安全管理" },
                cn: { name: "建筑及消防安全管理" },
              },
              name: "建築及消防安全管理",
            },
            {
              sequence: null,
              id: 24,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1629862081HLVIU/ll-esh-poison.png?signature=ee9549b5fd3fdec2e3f3cd3d6e3609f15b6b97332c8437d140905213bb68b683",
              locales: {
                tw: { name: "毒化物管理" },
                cn: { name: "毒化物管理" },
              },
              name: "毒化物管理",
            },
          ],
          locales: { tw: { name: "生產安全" }, cn: { name: "生产安全" } },
          name: "生產安全",
        },
        {
          id: 6,
          updated_at: "2020-10-03T13:45:09.000000Z",
          icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1597028930r0QNX/%E5%8B%9E%E5%B7%A5%E5%8F%8A%E8%81%B7%E6%A5%AD%E7%97%85.png?signature=ceb1f67c279fc1f598d8218bb5800671788e0aa98644e5cf2ed7a3a7d3d05151",
          system_subclasses: [
            {
              sequence: null,
              id: 21,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1597029246Lyb7U/%E5%8B%9E%E5%8B%95%E9%97%9C%E4%BF%82.png?signature=16c3fe242f89858efd2da13c6760ad22f7300ec47be18d0a5dace4d171d58815",
              locales: {
                tw: { name: "勞動關係管理" },
                cn: { name: "劳动关系管理" },
              },
              name: "勞動關係管理",
            },
            {
              sequence: null,
              id: 22,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1597029239w4xZJ/%E8%81%B7%E6%A5%AD%E7%97%85%E9%98%B2%E6%B2%BB.png?signature=57b5658cce35fd88917baac6254515663580dd200c94cc477984f94d3773b0fa",
              locales: {
                tw: { name: "職業安全衛生" },
                cn: { name: "职业安全卫生" },
              },
              name: "職業安全衛生",
            },
          ],
          locales: {
            tw: { name: "勞工及職業病" },
            cn: { name: "劳工及职业病" },
          },
          name: "勞工及職業病",
        },
        {
          id: 5,
          updated_at: "2021-08-25T03:26:10.000000Z",
          icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/16298619681la2p/ll-esh-specialized.png?signature=99c37447000e58bf639d77ca9abc012c3e328770a17c929fcd2ceee31cce1a26",
          system_subclasses: [
            {
              sequence: null,
              id: 20,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1629861988AjY7F/ll-esh-food-safety.png?signature=28833dd7d135b8aadb5599e0756cfd5a5a89e1527b00b8b5719e771f4e87bf3a",
              locales: {
                tw: { name: "食品安全衛生" },
                cn: { name: "食品安全卫生" },
              },
              name: "食品安全衛生",
            },
          ],
          locales: { tw: { name: "專門領域" }, cn: { name: "专门领域" } },
          name: "專門領域",
        },
        {
          id: 10,
          updated_at: "2021-08-25T03:25:02.000000Z",
          icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1629861901chtoD/ll-esh-common.png?signature=651f6c4f16bfb7e8a3fbcd9c1d86db094cce09be2eb8287e5de85c75552dc2ad",
          system_subclasses: [
            {
              sequence: "1",
              id: 26,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1629861938rotMB/ll-esh-common.png?signature=f1a2b540438276278e0ba587965e943bc598a011d4553ef117f811151698575d",
              locales: { tw: { name: "通用領域" } },
              name: "通用領域",
            },
            {
              sequence: "1",
              id: 28,
              icon: "https://api.ll-esh-app.wasateam.com/api/system_class/icon/1644926708wQ7Zn/screenshot%202022-02-15%20%E4%B8%8B%E5%8D%885.17.28.png?signature=28c3d5dc25e34fad6afd827c8b5faea192693cd52e7f1bd7ae17cdb72dc04c60",
              locales: { tw: { name: "20220215測試新增子領域" } },
              name: "20220215測試新增子領域",
            },
          ],
          locales: { tw: { name: "通用領域" } },
          name: "通用領域",
        },
      ];
      const result = systemClasses.map((systemClass) => {
        return {
          title: systemClass.name,
          value: systemClass.id,
          menu: systemClass.system_subclasses.map((subclass) => {
            return {
              text: subclass.name,
              value: subclass.id,
            };
          }),
        };
      });
      return result;
    },
  },
};
</script>

<style>
</style>